module.exports = __webpack_public_path__ + "static/zigzag-image1-6cbbc7936e7121fa15f1066a83f983e2.png";